import { __decorate, __metadata } from "tslib";
import { CrudEndpoints, Default, EditorDefinition, Expose, IsNumber, IdItemModel, ItemModelDefinition, ItemPathParam, MinLength, Trim, ItemModelProp, ModelId } from '@core/shared/model';
import { UseRestraints } from '@core/shared/restraints';
import { SceneRestraints } from './scene.restraints';
import { MEDIA_PROPS_ACCESSOR, MEDIA_PROPS_EDITORDEF, MediaAssets } from '@common/media/shared';
import { SCENE_SLIDES_MEDIA_SLOT, SceneType } from '@common/courses/shared';
let SceneItem = /*#__PURE__*/(() => {
  let SceneItem = class SceneItem extends IdItemModel {
    toString() {
      return "Scene " + this.name;
    }
  };
  __decorate([IsNumber(), ItemPathParam(), Expose(), ItemModelProp({
    defaultValueCreate: null
  }), __metadata("design:type", Number)], SceneItem.prototype, "courseId", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: true
  }), __metadata("design:type", Boolean)], SceneItem.prototype, "enabled", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], SceneItem.prototype, "creationDate", void 0);
  __decorate([Expose(), __metadata("design:type", Object)], SceneItem.prototype, "updateDate", void 0);
  __decorate([MinLength(3), Expose(), ItemModelProp({
    defaultValueCreate: ''
  }), Trim(), __metadata("design:type", String)], SceneItem.prototype, "name", void 0);
  __decorate([MinLength(3), Expose(), ItemModelProp({
    defaultValueCreate: SceneType.Video
  }), __metadata("design:type", String)], SceneItem.prototype, "type", void 0);
  __decorate([IsNumber(), Expose(), ItemModelProp({
    defaultValueCreate: 1000
  }), __metadata("design:type", Number)], SceneItem.prototype, "ordering", void 0);
  __decorate([Expose(), Default({}), __metadata("design:type", Object)], SceneItem.prototype, "data", void 0);
  __decorate([Expose(), ItemModelProp({
    defaultValueCreate: undefined,
    defaultValueUpdate: undefined
  }) // must be undefined, else PATCH would try to update userProgress to [] or similar.
  , __metadata("design:type", Array)], SceneItem.prototype, "userProgress", void 0);
  SceneItem = __decorate([EditorDefinition('admin', {
    name: true,
    type: true,
    ordering: true,
    data: true,
    courseId: 'readonly',
    [MEDIA_PROPS_ACCESSOR]: MEDIA_PROPS_EDITORDEF
  }, {
    useCrudEndpoint: 'admin'
  }), CrudEndpoints({
    admin: '/admin/courses/:courseId/scenes'
  }), UseRestraints(SceneRestraints), ItemModelDefinition({
    texts: {
      item: 'Szene',
      items: 'Szenen'
    }
  }), MediaAssets({
    video: {},
    [SCENE_SLIDES_MEDIA_SLOT]: {
      multiple: true
    }
  }), ModelId("SceneItem") // auto-generated by generate-model-ids
  ], SceneItem);
  return SceneItem;
})();
export { SceneItem };